import { LogMiddlewareServiceAttributes, LogMiddlewareServiceDetailAttributes } from "@albatrosdeveloper/ave-models-package";
import { CommonModule } from "@angular/common";
import { Component, Inject } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatOptionModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIcon } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import { MatPaginatorModule, PageEvent } from "@angular/material/paginator";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenav, MatSidenavContainer } from "@angular/material/sidenav";
import { MatSlideToggle } from "@angular/material/slide-toggle";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSortModule } from "@angular/material/sort";
import { MatRowDef, MatTableDataSource, MatTableModule } from "@angular/material/table";
import { MatTooltipModule } from "@angular/material/tooltip";
import { NgLabelTemplateDirective, NgOptionTemplateDirective, NgSelectComponent, NgSelectModule } from "@ng-select/ng-select";
import { TranslocoModule } from "@ngneat/transloco";
import { IPaginationResult, IRequestResult } from "app/common/interfaces";
import { LogsLatencyModalComponent } from "app/modules/components/synchronization/system-latency/logs-latency-modal/logs-latency-modal.component";
import { SystemLatencyService } from "app/modules/components/synchronization/system-latency/system-latency.service";
import { LogStatusEnum } from "@albatrosdeveloper/ave-models-package/lib/enums";
import { LogDetailDataModalComponent } from "../log-detail-data-modal/log-detail-data-modal.component";

@Component({
  selector: 'log-modal',
  standalone: true,
  templateUrl: './log-modal.component.html',
  styleUrl: './log-modal.component.scss',
  imports: [
    TranslocoModule,
    CommonModule,
    MatTableModule,
    MatDialogModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    MatIcon,
    MatSlideToggle,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatMenuModule,
    MatButtonModule,
    MatRowDef,
    MatSidenav,
    MatSidenavContainer,
    FormsModule,
    NgLabelTemplateDirective,
    NgOptionTemplateDirective,
    NgSelectComponent,
    NgSelectModule,
    MatDatepickerModule,
    LogsLatencyModalComponent
  ]
})

export class LogModalComponent {

  logStatusEnum = LogStatusEnum;

  //detail
  totalDetailItems = 0;
  searchDetail: string = '';
  pageSizeDetail: number = 50;
  pageIndexDetail: number = 1;
  sortActiveDetail: keyof LogMiddlewareServiceDetailAttributes = "createdAt";
  sortDirectionDetail: "ASC" | "DESC" = "DESC";

  displayedColumnsDetail: string[] = ["message", "createdAt", "dataSentHeader", "dataRecievedHeader", "dataSent", "dataRecieved", "status"]
  dataSourceDetail = new MatTableDataSource<LogMiddlewareServiceDetailAttributes>([]);

  constructor(
    private dialog: MatDialog,
    private systemLatencyService: SystemLatencyService,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<LogModalComponent>,
    private snckBar: MatSnackBar,

    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngAfterViewInit(): void {
    this.getListDetailLog(this.data);
  }

  getListDetailLog(data): void {
    let options = { currentPage: this.pageIndexDetail, limitPerPage: this.pageSizeDetail, search: this.searchDetail, sort: this.sortActiveDetail, sortDirection: this.sortDirectionDetail }

    let dataToSend = {
      documentIdentifier: data.documentIdentifier,
      type: data.type
    }

    this.systemLatencyService.findAllDetailWithCount2(options, dataToSend).subscribe({
      next: (res: IPaginationResult<LogMiddlewareServiceDetailAttributes>) => {
        this.dataSourceDetail.data = res?.data?.[0]?.data ?? [];
        this.totalDetailItems = res?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener registros", "Cerrar", { duration: 5000 });
      },
    });
  }

  changeSort(e) {
    this.sortActiveDetail = e.active
    this.sortDirectionDetail = e.direction == 'asc' ? 'ASC' : 'DESC'
    this.getListDetailLog(this.data);
  }

  onPageChange(event: PageEvent): void {
    this.pageSizeDetail = event.pageSize;
    this.pageIndexDetail = (event.pageIndex + 1);
    this.getListDetailLog(this.data);
  }

  openLogDetailDataModal(element): void {
    const dialogRef = this.dialog.open(LogDetailDataModalComponent, {
      width: "400px",
      data: element,
      disableClose: true
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
      }
    });
  }

  loadDataHeader(element, type): void {
    let headerId = element.logId;
    let jsonToSend = null
    this.systemLatencyService.findById(headerId).subscribe({
      next: (res: IRequestResult<LogMiddlewareServiceAttributes>) => {
        if (res.status == 'success') {
          if (type == 'dataSent') {
            jsonToSend = (res.data.data as any).sendData
          } else { //dataReceived
            jsonToSend = (res.data.data as any).receivedData
          }
          const dialogRef = this.dialog.open(LogDetailDataModalComponent, {
            width: "400px",
            data: jsonToSend ? jsonToSend : null,
            disableClose: true
          });
          dialogRef.afterClosed().subscribe((result) => {
            if (result) {
            }
          });
        }
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener registros", "Cerrar", { duration: 5000 });
      },
    });
  }

  formatDate(date: string | Date, includeTime?: boolean): string {
    if (date) {
      const d = new Date(date);
      const day = d.getDate().toString().padStart(2, '0');
      const month = (d.getMonth() + 1).toString().padStart(2, '0');
      const year = d.getFullYear();

      if (includeTime) {
        const hours = d.getHours().toString().padStart(2, '0');
        const minutes = d.getMinutes().toString().padStart(2, '0');
        const seconds = d.getSeconds().toString().padStart(2, '0');
        return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
      }
      return `${day}-${month}-${year}`;
    }
    return '--:--:--'
  }
}
